import { ethers } from "ethers";
import React from "react";
import styled from "styled-components";
import { RewardProps } from "..";
import Colors from "../../../styles/Colors";
import { H3 } from "../../../styles/Fonts";

const Summary: React.FC<{
  referreeCount: number;
  lastWeekReward: RewardProps;
}> = (props) => {
  const { referreeCount, lastWeekReward } = props;

  return (
    <Container>
      <SummaryContainer>
        <SummaryCol>
          <SummaryLabel>Total Users Referred</SummaryLabel>
          <SummaryValue>{referreeCount || 0}</SummaryValue>
        </SummaryCol>
        <SummaryCol>
          <SummaryLabel>Weekly Trading Volume</SummaryLabel>
          <SummaryValue>-</SummaryValue>
        </SummaryCol>
        <SummaryCol>
          <SummaryLabel>Weekly Rewards</SummaryLabel>
          <HighlightValue>
            {`${ethers.utils.formatUnits(
              +lastWeekReward?.Discount + +lastWeekReward?.Rebate || 0,
              6
            )} USDC`}
          </HighlightValue>
        </SummaryCol>
        <SummaryCol>
          <SummaryLabel>Current Week no.</SummaryLabel>
          <SummaryValue>
            {lastWeekReward?.RewardSession.WeekNumber
              ? lastWeekReward?.RewardSession.WeekNumber + 1
              : "-"}
          </SummaryValue>
        </SummaryCol>
      </SummaryContainer>
    </Container>
  );
};

export default Summary;

const Container = styled.div``;

const SummaryContainer = styled.div`
  margin-top: 28px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

const SummaryCol = styled.div`
  flex: 1 0 250px;
  background-color: ${Colors.backgroundGray2};
  padding: 24px;
  border-radius: 8px;
  @media (max-width: 768px) {
    padding: 18px;
  }
`;

const SummaryLabel = styled(H3)`
  font-size: 13px;
  line-height: 18px;
  color: ${Colors.gray4};
  margin-bottom: 12px;
  @media (max-width: 768px) {
    font-size: 12px;
    margin-bottom: 8px;
  }
`;

const SummaryValue = styled(H3)`
  font-size: 24px;
  line-height: 36px;
  font-weight: 700;
  color: ${Colors.ivory};
  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

const HighlightValue = styled(SummaryValue)`
  color: ${Colors.green};
`;
